<template>
  <div class="action">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
  .action {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>
